// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'inter', 'inter Fallback'"},"className":"__className_e703d9","variable":"__variable_e703d9"};